import createIcon from '../../createIcon';

/**
 * @component @name HourglassDisabled
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC43MDUwMiAzLjMzOTk3SDE2LjcwNVY2LjgzOTk3TDEzLjg2NSA5LjY3OTk3TDE1LjExNSAxMC45M0wxOC43MDUgNy4zNDk5N0wxOC42OTUgNy4zMzk5N0gxOC43MDVWMS4zMzk5N0g2LjcwNTAyVjIuNTA5OTdMOC43MDUwMiA0LjUwOTk3VjMuMzM5OTdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMi44MDUwMiAxLjQzOTk3TDEuMzk1MDIgMi44NDk5N0wxMC4yOTUgMTEuNzVMNi43MDUwMiAxNS4zNEw2LjcxNTAyIDE1LjM1SDYuNzA1MDJWMjEuMzRIMTguNzA1VjIwLjE3TDIxLjE5NSAyMi42NkwyMi42MDUgMjEuMjVMMi44MDUwMiAxLjQzOTk3Wk0xNi43MDUgMTkuMzRIOC43MDUwMlYxNS44NEwxMS41NDUgMTNMMTYuNzA1IDE4LjE3VjE5LjM0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HourglassDisabled = createIcon('HourglassDisabled', [
  [
    'path',
    {
      d: 'M8.70502 3.33997H16.705V6.83997L13.865 9.67997L15.115 10.93L18.705 7.34997L18.695 7.33997H18.705V1.33997H6.70502V2.50997L8.70502 4.50997V3.33997Z',
      key: '19gfms',
    },
  ],
  [
    'path',
    {
      d: 'M2.80502 1.43997L1.39502 2.84997L10.295 11.75L6.70502 15.34L6.71502 15.35H6.70502V21.34H18.705V20.17L21.195 22.66L22.605 21.25L2.80502 1.43997ZM16.705 19.34H8.70502V15.84L11.545 13L16.705 18.17V19.34Z',
      key: 'k9772t',
    },
  ],
]);

export default HourglassDisabled;
